import * as R from "ramda";
import { useMemo } from "react";
import {} from "prop-types";

import "./trends-table.scss";

import { formatPercentageNice } from "../../common/format.js";

import Table from "../Table/Table.jsx";

import { arrayOf, number, node, shape, string } from "prop-types";

const propTypes = {
  breakdownLabel: node.isRequired,
  indicator: shape({
    id: string.isRequired,
    name: string.isRequired,
    // description: null,
    // dataType: null,
    // subdistribution: { id: null, value: null },
  }).isRequired,
  lines: arrayOf(
    shape({
      id: string.isRequired,
      displayName: string.isRequired,
      color: string, // optional, will fallback to using COLORS
      dataPoints: arrayOf(
        shape({
          timeFrame: string.isRequired,
          value: number.isRequired,
        }),
      ).isRequired,
    }),
  ).isRequired,
};

const defaultProps = {
  lines: [],
};

const getChange = (dataPoints) => {
  const firstValue = R.compose(R.prop("value"), R.head)(dataPoints);
  const lastValue = R.compose(R.prop("value"), R.last)(dataPoints);

  return (lastValue - firstValue) / firstValue;
};

const TrendsTable = (props) => {
  const { breakdownLabel, indicator, lines } = props;

  const columns = useMemo(() => {
    return [
      {
        id: "breakdown",
        header: breakdownLabel,
        useTh: true,
        render: (line) => {
          return (
            <div className="trends-table__breakdown">
              {line.color ? (
                <div
                  className="trends-table__swatch"
                  style={{ backgroundColor: line.color }}
                ></div>
              ) : null}{" "}
              {line.displayName}
            </div>
          );
        },
        sortValueFn: R.prop("displayName"),
      },
      {
        id: "change",
        header: indicator?.name,
        render: (line) => {
          const change = getChange(line.dataPoints);

          return (
            <div className="trends-table__percentage">
              {formatPercentageNice(change)}{" "}
              {change > 0 ? upArrow : change < 0 ? downArrow : noArrow}
              {/* show icon only if greater than or less than 0. if 0, no icon */}
            </div>
          );
        },
        sortValueFn: (line) => getChange(line.dataPoints),
      },
    ];
  }, [breakdownLabel, indicator?.name]);

  return (
    <div className="trends-table">
      <Table columns={columns} data={lines} />
    </div>
  );
};

TrendsTable.defaultProps = defaultProps;
TrendsTable.propTypes = propTypes;
export default TrendsTable;

const upArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#000"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-arrow-up"
  >
    <title>Trend positive</title>
    <line x1="12" y1="19" x2="12" y2="5"></line>
    <polyline points="5 12 12 5 19 12"></polyline>
  </svg>
);

const downArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#000"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-arrow-down"
  >
    <title>Trend negative</title>
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <polyline points="19 12 12 19 5 12"></polyline>
  </svg>
);

const noArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden="true"
    width="14"
    height="7"
    viewBox="0 0 14 14"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-minus"
  >
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);
